/* oph-bespoke-quote.js — offertformulär: validering, spamskydd och sändning till Make (webhook -> mejl till info@ophira.se).
   Vanligt formulär (inte Shopifys contact-form). Ingen omladdning, tack-vyn visas i samma popup. */
(function () {
  var overlay = document.querySelector('[data-quote-overlay]');
  if (!overlay || !window.fetch) return;
  var form = overlay.querySelector('[data-quote-form]');
  var viewForm = overlay.querySelector('[data-quote-view="form"]');
  var viewSuccess = overlay.querySelector('[data-quote-view="success"]');
  if (!form || !viewForm || !viewSuccess) return;

  var HOOK = 'https://hook.eu1.make.com/dliakq4gwkupf1hvc7053xixhq6ht95h';
  var TOKEN = 'ophq-7f3k-2026';
  var MIN_MS = 2500;          /* snabbare än så är det en bot */
  var MAX_PER_WINDOW = 3;     /* max förfrågningar per besökare */
  var WINDOW_MS = 30 * 60 * 1000;
  var btn = form.querySelector('.oph-quote__submit');
  var formError = form.querySelector('[data-quote-form-error]');
  var sending = false, openedAt = Date.now(), human = false, submitted = false;

  function field(n) { return form.querySelector('[name="' + n + '"]'); }
  function val(n) { var el = field(n); return el ? el.value.trim() : ''; }
  function meta(k) { var el = form.querySelector('[data-meta="' + k + '"]'); return el ? el.value : ''; }

  /* ---- Validering: bara det viktiga (namn, e-post, telefon om ifylld) ---- */
  var RULES = {
    name: function (v) {
      if (v.length < 2) return 'Ange ditt namn';
      if (/https?:|www\./i.test(v)) return 'Ange ditt namn';
      return '';
    },
    email: function (v) {
      if (!v) return 'Ange din e-postadress';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return 'Ange en giltig e-postadress';
      return '';
    },
    phone: function (v) {
      if (!v) return '';
      if (!/^[+()\d][\d\s()+\-.]{4,24}$/.test(v) || v.replace(/\D/g, '').length < 6) return 'Ange ett giltigt telefonnummer';
      return '';
    }
  };
  function setError(name, msg) {
    var el = field(name), err = form.querySelector('[data-error-for="' + name + '"]');
    if (!el || !err) return;
    el.classList.toggle('is-invalid', !!msg);
    if (msg) { el.setAttribute('aria-invalid', 'true'); } else { el.removeAttribute('aria-invalid'); }
    err.textContent = msg; err.hidden = !msg;
  }
  function validateField(name) { var m = RULES[name](val(name)); setError(name, m); return !m; }
  function validateAll() {
    var firstBad = null;
    Object.keys(RULES).forEach(function (n) { if (!validateField(n) && !firstBad) firstBad = field(n); });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }
  Object.keys(RULES).forEach(function (n) {
    var el = field(n); if (!el) return;
    el.addEventListener('blur', function () { if (el.value.trim() !== '' || submitted) validateField(n); });
    el.addEventListener('input', function () { if (el.classList.contains('is-invalid')) validateField(n); });
  });

  /* ---- Spamskydd ---- */
  ['keydown', 'input', 'pointerdown', 'touchstart'].forEach(function (t) {
    form.addEventListener(t, function (e) { if (e.isTrusted) human = true; }, { passive: true });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-quote-open]'), function (t) {
    t.addEventListener('click', function () {
      openedAt = Date.now();
      if (!viewSuccess.hidden) {
        viewSuccess.hidden = true; viewSuccess.classList.remove('is-playing'); viewForm.hidden = false;
        form.reset(); clearErrors();
        var c = overlay.querySelector('[data-quote-count]'); if (c) c.textContent = '0';
      }
    });
  });
  function recentSends() {
    try {
      var a = JSON.parse(sessionStorage.getItem('oph_quote_sends') || '[]');
      var now = Date.now();
      return a.filter(function (t) { return now - t < WINDOW_MS; });
    } catch (e) { return []; }
  }
  function recordSend() {
    try { var a = recentSends(); a.push(Date.now()); sessionStorage.setItem('oph_quote_sends', JSON.stringify(a)); } catch (e) {}
  }

  /* ---- UI-hjälpare ---- */
  function showFormError(html) { formError.innerHTML = html; formError.hidden = false; }
  function clearErrors() {
    Object.keys(RULES).forEach(function (n) { setError(n, ''); });
    formError.hidden = true; formError.innerHTML = '';
  }
  function resetButton() {
    sending = false;
    if (btn) { btn.disabled = false; btn.textContent = 'Skicka förfrågan'; }
  }
  function showSuccess() {
    viewForm.hidden = true; viewSuccess.hidden = false;
    viewSuccess.classList.remove('is-playing'); void viewSuccess.offsetWidth; viewSuccess.classList.add('is-playing');
    resetButton();
  }

  function payload() {
    var q = new URLSearchParams(window.location.search), p = new URLSearchParams();
    var d = {
      token: TOKEN,
      hp: (form.querySelector('[data-quote-hp]') || {}).value || '',
      elapsed: String(Date.now() - openedAt),
      human: human ? '1' : '0',
      name: val('name'), email: val('email'), phone: val('phone'),
      metal: val('metal'), diamond: val('diamond'), message: val('message'),
      product: meta('product'), product_url: meta('product_url'), product_image: meta('product_image'),
      sku: meta('sku'), price: meta('price'),
      submitted_at: new Date().toISOString(),
      source_url: window.location.origin + window.location.pathname,
      referrer: document.referrer || '',
      utm_source: q.get('utm_source') || '', utm_medium: q.get('utm_medium') || '',
      utm_campaign: q.get('utm_campaign') || '', utm_content: q.get('utm_content') || '',
      utm_term: q.get('utm_term') || '', fbclid: q.get('fbclid') || '',
      gclid: q.get('gclid') || '', ttclid: q.get('ttclid') || ''
    };
    Object.keys(d).forEach(function (k) { p.append(k, d[k]); });
    return p;
  }

  function post(attempt) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
    return fetch(HOOK, { method: 'POST', body: payload(), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error('status ' + r.status); })
      .catch(function (err) {
        if (timer) clearTimeout(timer);
        if (attempt < 2) { return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return post(attempt + 1); }); }
        throw err;
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    submitted = true;
    formError.hidden = true;
    if (!validateAll()) return;

    /* Bot-fälla: ifyllt dolt fält => låtsas lyckas, skicka inget */
    var hp = form.querySelector('[data-quote-hp]');
    if (hp && hp.value.trim() !== '') { showSuccess(); return; }
    if (Date.now() - openedAt < MIN_MS) { showFormError('Vänta en liten stund och försök igen.'); return; }
    if (recentSends().length >= MAX_PER_WINDOW) {
      showFormError('Du har redan skickat flera förfrågningar. Mejla oss gärna på <a href="mailto:info@ophira.se">info@ophira.se</a>.');
      return;
    }

    sending = true;
    btn.disabled = true; btn.textContent = 'Skickar…';
    post(1).then(function () { recordSend(); showSuccess(); })
      .catch(function () {
        resetButton();
        showFormError('Vi kunde inte skicka just nu. Försök igen, eller mejla oss på <a href="mailto:info@ophira.se">info@ophira.se</a>.');
      });
  });
})();
